/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SystemStatusMessageTargetAttributeDTO
 */
export interface SystemStatusMessageTargetAttributeDTO {
    /**
     * 
     * @type {string}
     * @memberof SystemStatusMessageTargetAttributeDTO
     */
    attribute?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemStatusMessageTargetAttributeDTO
     */
    value?: string;
}

export function SystemStatusMessageTargetAttributeDTOFromJSON(json: any): SystemStatusMessageTargetAttributeDTO {
    return SystemStatusMessageTargetAttributeDTOFromJSONTyped(json, false);
}

export function SystemStatusMessageTargetAttributeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemStatusMessageTargetAttributeDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attribute': !exists(json, 'attribute') ? undefined : json['attribute'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function SystemStatusMessageTargetAttributeDTOToJSON(value?: SystemStatusMessageTargetAttributeDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attribute': value.attribute,
        'value': value.value,
    };
}

